export function ChangeCustomerCtrl ($scope, customer, inheritorApi) {
  $scope.customer = customer;

  inheritorApi.inheritCtrl('ChangeCustomerLiteCtrl', $scope);
}